module.exports = __webpack_public_path__ + "img/3-10-flight-deck.976a74dd.jpg";